// Pincode Checker Popup with Add To Cart
function initializeCustomAddToCart(quickBuyElement) {
  const addToCartButtons = document.querySelectorAll("#CustomAddToCart");
  addToCartButtons.forEach((button) => {
    // Guard against double-binding: buttons injected asynchronously (e.g. cart
    // recommendations) can be re-scanned multiple times.
    if (button.dataset.atcBound === "true") return;
    button.dataset.atcBound = "true";
    button.addEventListener("click", (e) => {
      handleCustomFormSubmit(e, quickBuyElement);
    });
  });
}

// Cart recommendations (cart page + mini-cart) are fetched and injected after
// load, so their quick-add buttons miss the initial binding. Watch each
// recommendations container and (re)bind whenever its contents change.
function watchRecommendationsForQuickAdd() {
  const containers = document.querySelectorAll(
    "product-recommendations, cart-drawer-recommendations",
  );
  containers.forEach((container) => {
    if (container.dataset.quickAddObserved === "true") return;
    container.dataset.quickAddObserved = "true";
    const observer = new MutationObserver(() => {
      initializeCustomAddToCart();
    });
    // subtree:false so we only react to the innerHTML swap of the container
    // itself, not to nested quick-buy drawers loading their own content.
    observer.observe(container, { childList: true });
  });
}

document.addEventListener("quick_buy_loaded", (e) => {
  const quickBuyElement = e.detail.element;
  initializeCustomAddToCart(quickBuyElement);
});

document.addEventListener("facet:criteria-changed", () => {
  console.log("called facet");
  setTimeout(() => {
    initializeCustomAddToCart();
  }, 500);
});

// The mini-cart section (and its recommendations element) is re-rendered on
// cart refresh, so re-attach observers and re-bind any present buttons.
document.addEventListener("cart:refresh", () => {
  watchRecommendationsForQuickAdd();
  initializeCustomAddToCart();
});

document.addEventListener("DOMContentLoaded", () => {
  initializeCustomAddToCart();
  watchRecommendationsForQuickAdd();
});

const DELIVERY_PINCODE_CHECK_URL =
  "https://manam.apps.iterator.in/api/stores/check-delivery-pincode/";

const PINCODE_FAIL_COPY = {
  local: {
    title: "We are currently not delivering this product to your pincode",
    subtitleHtml:
      "This product is temperature-sensitive and may lose quality in high temperatures. Browse our Snacking and Tablet craft chocolate experiences.",
  },
  default: {
    title: "Uh-Oh! we're not delivering to this area yet!",
    subtitleHtml:
      "We're working on expanding our delivery areas. Leave your email address,<br>and we'll let you know once we're available in your<br>location.",
  },
};

// ----------------------------------------------------------------------------
// Delivery badge helpers (shared with the <delivery-badge> custom element)
// ----------------------------------------------------------------------------

// Normalise the delivery type returned by the API to "local" | "pan".
// The exact API field is read defensively; falls back to the product tag.
function normalizeDeliveryType(data, panFallback) {
  const raw = (
    (data &&
      (data.delivery_type ||
        data.deliveryType ||
        data.type ||
        (data.delivery && data.delivery.type))) ||
    ""
  )
    .toString()
    .toLowerCase();
  console.log(raw);
  if (raw.includes("pan")) return "pan";
  if (raw.includes("local")) return "local";
  return panFallback ? "pan" : "local";
}

// Read the turnaround time (hours) from the API response. Delhi/Hyderabad
// (local) don't need it; for other states a TAT >= the configured threshold
// (e.g. 48) switches the badge to the extended delivery/weekend rules.
function readDeliveryTat(data) {
  const raw =
    data &&
    ((data.metadata && data.metadata.tat != null ? data.metadata.tat : null) ??
      data.tat);
  const n = parseInt(raw, 10);
  return Number.isNaN(n) ? null : n;
}

// True when the pincode API marks this pincode same-day (metadata.tat === "SDD").
// This is a string marker, distinct from the numeric TAT read above.
function readDeliverySdd(data) {
  const raw =
    data &&
    ((data.metadata && data.metadata.tat != null ? data.metadata.tat : null) ??
      data.tat);
  return String(raw).trim().toUpperCase() === "SDD";
}

// Persist the resolved delivery type + pincode and notify any badge on the page.
window.storeDeliveryType = function storeDeliveryType(
  data,
  panFallback,
  pincode,
) {
  const deliveryType = normalizeDeliveryType(data, panFallback);
  localStorage.setItem("delivery_type", deliveryType);
  const tat = readDeliveryTat(data);
  if (tat != null) {
    localStorage.setItem("delivery_tat", String(tat));
  } else {
    localStorage.removeItem("delivery_tat");
  }
  if (readDeliverySdd(data)) {
    localStorage.setItem("delivery_sdd", "true");
  } else {
    localStorage.removeItem("delivery_sdd");
  }
  localStorage.removeItem("delivery_failed_pincode");
  if (pincode) localStorage.setItem("pincode", pincode);
  document.documentElement.dispatchEvent(
    new CustomEvent("delivery:updated", {
      bubbles: true,
      detail: {
        pincode: pincode || localStorage.getItem("pincode"),
        deliveryType,
      },
    }),
  );
};

// Mark the last-checked pincode as unavailable so the badge shows its
// "Delivery unavailable" state, and notify any badge on the page.
function markDeliveryFailed(pincode) {
  if (pincode) localStorage.setItem("delivery_failed_pincode", pincode);
  document.documentElement.dispatchEvent(
    new CustomEvent("delivery:updated", { bubbles: true }),
  );
}

function syncPincodeProductLocalFromSource(sourceEl) {
  if (!sourceEl?.getAttribute) return;
  const local = sourceEl.getAttribute("data-product-local");
  if (local !== "true" && local !== "false") return;
  document.querySelectorAll("pincode-checker").forEach((checker) => {
    checker.setAttribute("data-product-local", local);
    if (typeof checker.syncFailedDeliveryMessages === "function") {
      checker.syncFailedDeliveryMessages();
    }
  });
}

async function fetchDeliveryServiceable(pincode, productId) {
  const res = await fetch(
    `${DELIVERY_PINCODE_CHECK_URL}?pincode=${encodeURIComponent(
      pincode,
    )}&product=${encodeURIComponent(productId)}`,
  );
  const data = await res.json();
  return { ok: res.ok, data };
}

const CUSTOM_ATC_SPINNER_HTML = `<div class="spinner" aria-hidden="true"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div>`;

function showGiftCardFieldError(input, message) {
  const wrapper = input.closest(".input");
  const error = document.createElement("p");
  error.className = "form-error";
  error.style.textAlign = "left";
  error.style.margin = "4px 0 0";
  error.textContent = message;
  wrapper.appendChild(error);
  input.focus();
  input.addEventListener(
    "input",
    () => {
      const existing = wrapper.querySelector(".form-error");
      if (existing) existing.remove();
    },
    { once: true },
  );
}

function setCustomAddToCartLoading(button, loading) {
  if (!button) return;
  if (loading) {
    if (button.hasAttribute("data-custom-atc-loading")) return;
    button.setAttribute("data-custom-atc-loading", "");
    button.dataset.customAtcPrevDisabled = button.disabled ? "1" : "0";
    button.dataset.customAtcPrevHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.classList.add("custom-add-to-cart--loading");
    button.innerHTML = `<span class="custom-add-to-cart-loading" style="display:inline-flex;align-items:center;justify-content:center;height:100%;">${CUSTOM_ATC_SPINNER_HTML}</span>`;
  } else {
    if (!button.hasAttribute("data-custom-atc-loading")) return;
    button.removeAttribute("data-custom-atc-loading");
    const prevDisabled = button.dataset.customAtcPrevDisabled === "1";
    delete button.dataset.customAtcPrevDisabled;
    button.removeAttribute("aria-busy");
    button.classList.remove("custom-add-to-cart--loading");
    if (button.dataset.customAtcPrevHtml !== undefined) {
      button.innerHTML = button.dataset.customAtcPrevHtml;
      delete button.dataset.customAtcPrevHtml;
    }
    button.disabled = prevDisabled;
  }
}

async function handleCustomFormSubmit(e, quickBuyElement) {
  e.preventDefault();

  const addButton = e.currentTarget;

  if (addButton.dataset.isGiftCard === "true") {
    const formElement = document.getElementById(addButton.dataset.formId);
    const emailInput =
      formElement &&
      formElement.querySelector('[name="properties[Recipient email]"]');
    if (emailInput) {
      const errorEl = emailInput.closest(".input").querySelector(".form-error");
      if (errorEl) errorEl.remove();
      if (!emailInput.value.trim()) {
        showGiftCardFieldError(emailInput, "Recipient email is required.");
        return;
      }
      if (!emailInput.validity.valid) {
        showGiftCardFieldError(
          emailInput,
          "Please enter a valid email address.",
        );
        return;
      }
    }
    if (quickBuyElement) quickBuyElement.removeAttribute("open");
    setCustomAddToCartLoading(addButton, true);
    try {
      await addProductsToCart(formElement, null, true);
    } finally {
      setCustomAddToCartLoading(addButton, false);
    }
    return;
  }

  const pincodeElement = document.querySelector("pincode-checker");
  if (pincodeElement) {
    // Adding to cart from a product form should submit on success, not behave
    // like a cart "change pincode" (which only closes the modal).
    pincodeElement.removeAttribute("data-cart-pincode");
    pincodeElement.setAttribute("data-product-id", addButton.dataset.productId);
    pincodeElement.setAttribute(
      "data-product-title",
      addButton.dataset.productTitle,
    );
    pincodeElement.setAttribute("data-form-id", addButton.dataset.formId);
    syncPincodeProductLocalFromSource(addButton);
    const pincodeModal = pincodeElement.querySelector(`#pincode-checker-modal`);

    console.log("PincodeModal->>>", pincodeModal);
    const savedPincode = localStorage.getItem("pincode");
    if (!savedPincode) {
      pincodeModal.setAttribute("open", "");
      if (quickBuyElement) quickBuyElement.removeAttribute("open");
      return;
    }

    const formElement = document.getElementById(addButton.dataset.formId);
    const productId = addButton.dataset.productId;

    if (quickBuyElement) quickBuyElement.removeAttribute("open");

    const pincodeDigits = String(savedPincode).replace(/\D/g, "");
    if (pincodeDigits.length !== 6) {
      pincodeElement.openPincodeModalForManualCheck(savedPincode);
      return;
    }

    setCustomAddToCartLoading(addButton, true);
    try {
      const { data } = await fetchDeliveryServiceable(pincodeDigits, productId);
      if (data?.serviceable) {
        localStorage.setItem("pincode", pincodeDigits);
        localStorage.setItem("productId", productId);
        window.storeDeliveryType(
          data,
          pincodeElement.getAttribute("data-panindia") === "true",
          pincodeDigits,
        );
        await addProductsToCart(formElement, pincodeModal);
      } else {
        pincodeElement.showDeliveryUnavailable(pincodeDigits, data);
      }
    } catch (err) {
      console.log("Pincode verify before cart error: ", err);
      pincodeElement.openPincodeModalForManualCheck(pincodeDigits);
    } finally {
      setCustomAddToCartLoading(addButton, false);
    }
  }
}

async function addProductsToCart(formElement, pincodeModal, isGiftCard) {
  if (!formElement) {
    if (pincodeModal && pincodeModal.hasAttribute("open"))
      pincodeModal.removeAttribute("open");
    return;
  }

  const productForm = new FormData(formElement);
  productForm.append("sections", ["mini-cart"]);
  productForm.delete("option1");
  productForm.delete("option2");
  productForm.delete("option3");

  if (isGiftCard) {
    const variantId = productForm.get("id");
    if (variantId)
      productForm.append("properties[_gift_card_variant_id]", variantId);
  }
  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    },
  );
  const responseJson = await response.json();
  console.log("responseJson", responseJson);
  if (response.ok) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      return (window.location.href = `${Shopify.routes.root}cart`);
    }
    const variantEventTarget = formElement || document.documentElement;
    variantEventTarget.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      }),
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          }),
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          }),
        );
        const cart = document.getElementById("mini-cart");
        cart.setAttribute("open", "");
      },
    );
    if (pincodeModal && pincodeModal.hasAttribute("open")) {
      pincodeModal.removeAttribute("open");
    }
  }
}

class PincodeCheckerForm extends HTMLElement {
  constructor() {
    super();
    this.panIndia = this.getAttribute("data-panindia") === "true";
    this.twelveKMProduct =
      this.getAttribute("data-twelve-km-product") === "true";

    this.pincodeModal = this.querySelector(".pincode-checker-modal");
    this.pincodeCheckerContent = this.querySelector(".pincode-checker-content");
    this.pincodeForm = this.querySelector(".pincode-form");
    this.deliveryMsg = this.querySelector(".delivering");
    this.pincodeInput = this.querySelector(".pincodeNumber");
    this.pincodeCheckerButton = this.querySelector(".pincodeChecker");
    this.sendUserDetailButton = this.querySelector(".sendUserDetails");
    this.failedPincodesDetails = this.querySelector(".failed_pincodes_details");
    this.changePincodeBtn = this.querySelector(".new_pincode_check");
    this.failedTitleEl = this.failedPincodesDetails?.querySelector(".title");
    this.failedSubtitleEl =
      this.failedPincodesDetails?.querySelector(".sub-title");
  }

  syncFailedDeliveryMessages() {
    const isLocal = this.getAttribute("data-product-local") === "true";
    const copy = isLocal ? PINCODE_FAIL_COPY.local : PINCODE_FAIL_COPY.default;
    if (this.failedTitleEl) {
      this.failedTitleEl.textContent = copy.title;
    }
    if (this.failedSubtitleEl) {
      this.failedSubtitleEl.innerHTML = copy.subtitleHtml;
    }
  }

  showDeliveryUnavailable(pincodeDigits, apiData) {
    localStorage.removeItem("delivery_type");
    localStorage.removeItem("delivery_tat");
    localStorage.removeItem("delivery_sdd");
    markDeliveryFailed(pincodeDigits);
    this.syncFailedDeliveryMessages();
    if (this.pincodeInput) this.pincodeInput.value = pincodeDigits;
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.style.backgroundColor = "";
      this.pincodeCheckerButton.textContent = "CHECK";
    }
    this.pincodeCheckerContent.style.display = "none";
    this.failedPincodesDetails.style.display = "block";
    this.failedPincodeId = apiData?.failed_pincode_id || null;
    this.pincodeModal.setAttribute("open", "");
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true }),
    );
  }

  openPincodeModalForManualCheck(pincodeValue) {
    this.pincodeCheckerContent.style.display = "block";
    this.failedPincodesDetails.style.display = "none";
    if (this.pincodeInput) this.pincodeInput.value = pincodeValue || "";
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.style.backgroundColor = "";
      this.pincodeCheckerButton.textContent = "CHECK";
    }
    this.pincodeModal.setAttribute("open", "");
  }

  connectedCallback() {
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.addEventListener(
        "click",
        this.checkPincode.bind(this),
      );
    }

    if (this.sendUserDetailButton) {
      this.sendUserDetailButton.addEventListener(
        "click",
        this.sendFailedPincodes.bind(this),
      );
    }
    if (this.changePincodeBtn) {
      this.changePincodeBtn?.addEventListener(
        "click",
        this.changePincode.bind(this),
      );
    }
    if (this.pincodeInput) {
      this.pincodeInput.addEventListener("keydown", (event) => {
        const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
        if (!/\d/.test(event.key) && !allowedKeys.includes(event.key)) {
          event.preventDefault();
        }
      });
      this.pincodeInput.addEventListener("input", (event) => {
        event.target.value = event.target.value.replace(/\D/g, "");
      });
    }

    const cookieVal = localStorage.getItem("pincode");
    const cookieProductId = localStorage.getItem("productId");
    if (cookieVal && cookieProductId) {
      this.pincodeInput.value = cookieVal;
      setTimeout(() => {
        this.pincodeCheckerButton.click();
      }, 1000);
    }

    this.syncFailedDeliveryMessages();
  }

  async checkPincode(e) {
    const productId =
      this.getAttribute("data-product-id") || localStorage.getItem("productId");
    const pincodeNumber = this.pincodeInput.value;

    if (pincodeNumber.length === 6) {
      console.log("Pincode entered:", pincodeNumber);
      try {
        const { data } = await fetchDeliveryServiceable(
          pincodeNumber,
          productId,
        );

        if (data?.serviceable) {
          localStorage.setItem("pincode", pincodeNumber);
          localStorage.setItem("productId", productId);
          window.storeDeliveryType(data, this.panIndia, pincodeNumber);
          this.pincodeCheckerButton.style.backgroundColor = "#48B02C";
          this.pincodeCheckerButton.textContent = "DELIVERY AVAILABLE";

          if (this.getAttribute("data-cart-pincode")) {
            this.pincodeModal.removeAttribute("open");
          }
          if (
            this.pincodeModal.hasAttribute("open") &&
            !this.getAttribute("data-cart-pincode")
          ) {
            this.handleFormSubmit(e);
          }
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true }),
          );
        } else {
          localStorage.removeItem("pincode");
          localStorage.removeItem("productId");
          localStorage.removeItem("delivery_type");
          localStorage.removeItem("delivery_tat");
          localStorage.removeItem("delivery_sdd");
          markDeliveryFailed(pincodeNumber);
          this.syncFailedDeliveryMessages();
          this.pincodeCheckerContent.style.display = "none";
          this.failedPincodesDetails.style.display = "block";

          this.failedPincodeId = data?.failed_pincode_id || null;
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true }),
          );
        }
      } catch (error) {
        console.log("Error: ", error);
      }
    }
  }

  changePincode() {
    this.pincodeCheckerContent.style.display = "block";
    this.pincodeInput.focus();
    this.failedPincodesDetails.style.display = "none";
  }

  async sendFailedPincodes() {
    const url = `https://manam.apps.iterator.in/api/stores/failed-delivery-pincodes/${this.failedPincodeId}/`;
    const email = this.querySelector("#user_email_address")?.value?.trim();
    const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    console.log(email);
    if (!email || !emailRegExp.test(email)) {
      this.querySelector(".pincode_error").style.display = "block";
      this.querySelector(".pincode_error").innerHTML = `
        <span style='display: flex; align-items: center; gap: 5px;'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 20' fill='none'>
            <path d='M13.5 6L6 13.5' stroke='#E03232' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
            <path d='M6 6L13.5 13.5' stroke='#E03232' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
          </svg>
          Enter a valid email address.
        </span>`;
      return;
    }

    const payload = {
      pincode: this.pincodeInput?.value,
      email: email,
      product: this.getAttribute("data-product-id"),
    };

    const pincodeModal = this.pincodeModal;
    const sendUserDetailButton = this.sendUserDetailButton;

    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      console.log("data", data);

      if (res.ok) {
        sendUserDetailButton.style.backgroundColor = "#48B02C";
        sendUserDetailButton.textContent = "You will be notified!!";

        setTimeout(() => {
          pincodeModal.removeAttribute("open");
        }, 2000);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  async handleFormSubmit(e) {
    const formId = this.getAttribute("data-form-id");
    const productForm = document.getElementById(formId);
    await addProductsToCart(productForm, this.pincodeModal);
  }
}

window.customElements.define("pincode-checker", PincodeCheckerForm);

// Opens the pincode checker modal pre-filled with the saved pincode so the
// shopper can change it. Shared by the cart delivery badge (and any other
// "change pincode" affordance).
window.openPincodeChangeModal = function openPincodeChangeModal(opts) {
  opts = opts || {};
  const checker = document.querySelector("pincode-checker");
  if (!checker) return;

  if (opts.productId) checker.setAttribute("data-product-id", opts.productId);
  if (opts.productTitle)
    checker.setAttribute("data-product-title", opts.productTitle);
  if (opts.productLocal === "true" || opts.productLocal === "false") {
    checker.setAttribute("data-product-local", opts.productLocal);
    if (typeof checker.syncFailedDeliveryMessages === "function") {
      checker.syncFailedDeliveryMessages();
    }
  }

  // This is a "change pincode" action, not an add-to-cart — flag it so that a
  // successful check just closes the modal instead of adding the product.
  // (Cleared at the start of the next real Add-to-Cart in handleCustomFormSubmit.)
  checker.setAttribute("data-cart-pincode", true);
  if (opts.fromCart) {
    const cart = document.getElementById("mini-cart");
    if (cart) cart.removeAttribute("open");
  }

  const checkButton = checker.querySelector(".pincodeChecker");
  if (checkButton) {
    checkButton.style.backgroundColor = "";
    checkButton.style.color = "";
    checkButton.textContent = "CHECK";
  }

  // Show the input view (not the "unavailable" view), pre-filled, and open.
  const prefill =
    opts.pincode ||
    localStorage.getItem("pincode") ||
    localStorage.getItem("delivery_failed_pincode") ||
    "";
  if (typeof checker.openPincodeModalForManualCheck === "function") {
    checker.openPincodeModalForManualCheck(prefill);
  } else {
    const modal = checker.querySelector(".pincode-checker-modal");
    if (modal) modal.setAttribute("open", "");
  }
};

window.updatePincodeOnCart = function updatePincodeDetailsCart() {
  const pincodeDetailsElem = document.querySelector(
    ".mini-cart__pincode-details",
  );
  if (!pincodeDetailsElem) return;

  const hasPincode =
    localStorage.getItem("pincode") && localStorage.getItem("productId");
  // No delivery-badge is rendered when the cart is gift-cards only (see
  // mini-cart.liquid) — keep the wrapper hidden in that case.
  const hasBadge = !!pincodeDetailsElem.querySelector("delivery-badge");
  pincodeDetailsElem.style.display = hasPincode && hasBadge ? "flex" : "none";
};

document.addEventListener("cart:refresh", window.updatePincodeOnCart);

// ----------------------------------------------------------------------------
// <delivery-badge> — dynamic "Ships Today / Same Day Delivery / Ships Monday"
// badge shown above Add to Cart. All timing + copy come from theme settings
// (rendered as data-* attributes in snippets/delivery-badge.liquid).
// ----------------------------------------------------------------------------

// Fallback copy if a theme setting is blank (mirrors settings_schema defaults).
const DELIVERY_BADGE_DEFAULTS = {
  no_pincode: "Check pincode for delivery date",
  local: "Delivery by {date} to {pincode}",
  pan: "Delivery by {date} to {pincode}",
  sdd: "Same Day Delivery to {pincode}",
  failed: "Delivery not available at {pincode}",
};

// DIWALI-2026-SCHEDULE — temporary fixed delivery dates by order date; enabled
// by the "Diwali delivery schedule" theme setting. Remove after 6 Nov 2026.
const DIWALI_DELIVERY_SCHEDULE = [
  { order: "2026-11-02", delivery: "2026-11-05", scope: "all" },
  { order: "2026-11-03", delivery: "2026-11-05", scope: "all" },
  { order: "2026-11-04", delivery: "2026-11-06", scope: "all" },
  { order: "2026-11-05", delivery: "2026-11-06", scope: "local" },
];

function escapeHtml(value) {
  return String(value).replace(
    /[&<>"']/g,
    (c) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[c],
  );
}

// Replace {date} {countdown} {pincode} {cutoff} with highlighted spans.
// When opts.pincodeClickable is true, the {pincode} value becomes a button
// that opens the pincode checker modal (used inside the cart).
function fillBadgeTemplate(template, values, opts) {
  const pincodeClickable = opts && opts.pincodeClickable;
  return escapeHtml(template).replace(
    /\{(date|countdown|pincode|cutoff)\}/g,
    (match, key) => {
      const value = values[key] != null ? escapeHtml(String(values[key])) : "";
      let className = "delivery-badge__hl";
      let attrs = "";
      if (key === "pincode" && pincodeClickable) {
        className += " delivery-badge__pincode";
        attrs = ' role="button" tabindex="0"';
      }
      return `<span class="${className}"${attrs}>${value}</span>`;
    },
  );
}

// ----------------------------------------------------------------------------
// Delivery estimate — the "when does this arrive" rules behind the delivery
// badge, shared with the cart's <delivery-options> ("Arrives by {date}").
// Timing config comes from the data-* attributes rendered by
// snippets/delivery-timing-attrs.liquid (theme settings → Delivery Badge);
// per-surface flags (context, SDD eligibility, default type) come with it.
// ----------------------------------------------------------------------------
function deliveryConfig(dataset, overrides) {
  const data = dataset || {};
  const intAttr = (name, fallback) => {
    const n = parseInt(data[name], 10);
    return Number.isNaN(n) ? fallback : n;
  };

  const cfg = {
    // Timing rules, all IST.
    cutoffHour: intAttr("cutoffHour", 19),
    localDeliveryDays: intAttr("localDeliveryDays", 2),
    panDispatchBefore: intAttr("panDispatchBefore", 1),
    panDispatchAfter: intAttr("panDispatchAfter", 2),
    panTransit: intAttr("panTransit", 1),
    panTransitExtended: intAttr("panTransitExtended", 2),
    extendedTatThreshold: intAttr("extendedTatThreshold", 48),
    panWeekendDay: intAttr("panWeekendDay", 2), // Tuesday
    panWeekendDayExtended: intAttr("panWeekendDayExtended", 3), // Wednesday
    // Holiday dates (no delivery) from theme settings, as a Set of "YYYY-MM-DD".
    holidays: new Set(
      String(data.holidays || "")
        .split(/[\s,]+/)
        .filter((v) => /^\d{4}-\d{2}-\d{2}$/.test(v)),
    ),

    // DIWALI-2026-SCHEDULE
    dateOverrides:
      data.diwaliSchedule === "true" ? DIWALI_DELIVERY_SCHEDULE : [],

    defaultType: data.defaultType || "local",
    // Same-day delivery gating: on the product page the product's own SDD tag
    // applies; in the cart it only goes same-day when every line item is
    // SDD-eligible (data-cart-all-sdd, computed in Liquid).
    cartContext: data.context === "cart",
    productSdd: data.productSdd === "true",
    cartAllSdd: data.cartAllSdd === "true",
  };

  return overrides ? Object.assign(cfg, overrides) : cfg;
}

// Current wall-clock + calendar date in IST (Asia/Kolkata), independent of
// the browser timezone.
function istNow() {
  const parts = {};
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    weekday: "short",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
    .formatToParts(new Date())
    .forEach((p) => {
      parts[p.type] = p.value;
    });
  const days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  let hour = parseInt(parts.hour, 10);
  if (hour === 24) hour = 0; // some engines emit "24" at midnight
  return {
    day: days[parts.weekday],
    year: parseInt(parts.year, 10),
    month: parseInt(parts.month, 10), // 1-12
    date: parseInt(parts.day, 10),
    hour,
    minute: parseInt(parts.minute, 10),
    second: parseInt(parts.second, 10),
  };
}

// Whether the (other-states) pincode uses the extended turnaround time.
function isExtendedTat(cfg) {
  const tat = parseInt(localStorage.getItem("delivery_tat"), 10);
  return !Number.isNaN(tat) && tat >= cfg.extendedTatThreshold;
}

// Number of calendar days from "today" (IST) to the estimated delivery date,
// per the delivery matrix.
function deliveryOffsetDays(cfg, t, deliveryType) {
  // Local (Delhi & Hyderabad): fixed days, every day. Orders placed after the
  // daily cutoff miss today's dispatch, so push the estimate out by one day.
  if (deliveryType !== "pan") {
    const afterCutoff = t.hour >= cfg.cutoffHour ? 1 : 0;
    return cfg.localDeliveryDays + afterCutoff;
  }

  const extended = isExtendedTat(cfg);

  // Weekend orders (Sat/Sun) deliver on a fixed weekday.
  if (t.day === 6 || t.day === 0) {
    const shipDay = extended ? cfg.panWeekendDayExtended : cfg.panWeekendDay;
    const diff = (shipDay - t.day + 7) % 7;
    return diff === 0 ? 7 : diff;
  }

  // Weekday orders: dispatch offset depends on the cutoff, then transit time.
  const dispatch =
    t.hour < cfg.cutoffHour ? cfg.panDispatchBefore : cfg.panDispatchAfter;
  const transit = extended ? cfg.panTransitExtended : cfg.panTransit;
  return dispatch + transit;
}

// The estimated delivery date as a neutral-UTC Date. Day arithmetic runs on a
// UTC calendar so it is unaffected by the browser timezone.
// DIWALI-2026-SCHEDULE: fixed delivery date for the order's effective date
// (orders at/after the cutoff hour count as the next day), or null.
function findDateOverride(cfg, t, deliveryType) {
  if (!cfg.dateOverrides || !cfg.dateOverrides.length) return null;
  const order = new Date(
    Date.UTC(t.year, t.month - 1, t.date) +
      (t.hour >= cfg.cutoffHour ? 86400000 : 0),
  );
  const orderISO = utcISO(order);
  const type = deliveryType === "pan" ? "pan" : "local";
  const rule = cfg.dateOverrides.find(
    (r) => r.order === orderISO && (r.scope === "all" || r.scope === type),
  );
  if (!rule) return null;
  const [y, m, d] = rule.delivery.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

function deliveryTarget(cfg, t, deliveryType, offsetOverride) {
  if (offsetOverride == null) {
    const fixed = findDateOverride(cfg, t, deliveryType);
    if (fixed) return fixed;
  }
  const offset =
    offsetOverride != null
      ? offsetOverride
      : deliveryOffsetDays(cfg, t, deliveryType);
  const target = new Date(
    Date.UTC(t.year, t.month - 1, t.date) + offset * 86400000,
  );
  // We don't deliver on Sundays, Mondays or holidays (theme settings) — push
  // the date forward to the next deliverable day. Capped as a safety guard.
  for (let i = 0; i < 60 && !isDeliveryDay(cfg, target); i++) {
    target.setUTCDate(target.getUTCDate() + 1);
  }
  return target;
}

// "YYYY-MM-DD" of a neutral-UTC Date.
function utcISO(d) {
  const pad2 = (n) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

// Whether a neutral-UTC date is a delivery day (not Sunday/Monday/holiday).
function isDeliveryDay(cfg, d) {
  const day = d.getUTCDay();
  return day !== 0 && day !== 1 && !cfg.holidays.has(utcISO(d));
}

// "Tue, 15 Jul" for the estimated delivery date.
function formatDeliveryDate(cfg, t, deliveryType, offsetOverride) {
  const target = deliveryTarget(cfg, t, deliveryType, offsetOverride);
  const parts = {};
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    weekday: "short",
    day: "numeric",
    month: "short",
  })
    .formatToParts(target)
    .forEach((p) => {
      parts[p.type] = p.value;
    });
  return `${parts.weekday}, ${parts.day} ${parts.month}`;
}

// "Xh Ym" until today's cutoff (0 once passed) — for an optional urgency hint.
function deliveryCountdown(cfg, t) {
  const nowMin = t.hour * 60 + t.minute + t.second / 60;
  let mins = cfg.cutoffHour * 60 - nowMin;
  if (mins < 0) mins = 0;
  const h = Math.floor(mins / 60);
  const m = Math.floor(mins % 60);
  return `${h}h ${m}m`;
}

function formatCutoff(cfg) {
  const h = ((cfg.cutoffHour % 24) + 24) % 24;
  const ampm = h >= 12 ? "PM" : "AM";
  let hr = h % 12;
  if (hr === 0) hr = 12;
  return `${hr} ${ampm}`;
}

// Everything a surface needs to describe the delivery: which state it is in
// (key), the estimated date and the badge placeholder values.
function estimateDelivery(cfg) {
  const t = istNow();
  const pincode = localStorage.getItem("pincode");
  const failedPincode = localStorage.getItem("delivery_failed_pincode");
  const deliveryType = localStorage.getItem("delivery_type") || cfg.defaultType;

  // Same-day requires both signals: the product's SDD tag (all items in cart
  // context) and the checked pincode's TAT marker (delivery_sdd).
  const pincodeIsSdd = localStorage.getItem("delivery_sdd") === "true";
  const productIsSdd = cfg.cartContext ? cfg.cartAllSdd : cfg.productSdd;
  const sddEligible = !!pincode && pincodeIsSdd && productIsSdd;
  // Same-day is only achievable on a delivery day (not Sunday or Monday)
  // before the cutoff; otherwise an SDD product falls back to a later estimate.
  const todayUTC = new Date(Date.UTC(t.year, t.month - 1, t.date));
  const sddFeasible = isDeliveryDay(cfg, todayUTC) && t.hour < cfg.cutoffHour;
  const isSdd = sddEligible && sddFeasible;

  let key;
  if (pincode) {
    key = isSdd ? "sdd" : deliveryType === "pan" ? "pan" : "local";
  } else if (failedPincode) {
    key = "failed";
  } else {
    key = "no_pincode";
  }

  // Date: "Today" when same-day is actually feasible; otherwise the standard
  // estimate for this delivery type. When an SDD order misses the same-day
  // window (after cutoff, or Sunday) we must NOT assume a flat next-day — an
  // after-cutoff order won't dispatch same-day, so it has to run through the
  // normal cutoff/transit/weekend rules like any other order.
  let dateValue = "";
  let dateISO = "";
  const pad2 = (n) => String(n).padStart(2, "0");
  if (pincode) {
    if (isSdd) {
      dateValue = "Today";
      dateISO = `${t.year}-${pad2(t.month)}-${pad2(t.date)}`;
    } else {
      dateValue = formatDeliveryDate(cfg, t, deliveryType);
      dateISO = utcISO(deliveryTarget(cfg, t, deliveryType));
    }
  }

  return {
    key,
    isSdd,
    isFailed: key === "failed",
    isPrompt: key === "no_pincode",
    pincode,
    failedPincode,
    displayPincode: pincode || failedPincode,
    dateValue,
    dateISO,
    countdown: deliveryCountdown(cfg, t),
    cutoff: formatCutoff(cfg),
  };
}

// Publish the estimate so every surface stays in sync: the cart's "Arrives by
// {date}" row, the "DELIVERY TO {pincode}" header, and the datepicker's
// earliest selectable date (localStorage.delivery_by_iso).
function publishDeliveryEstimate(estimate) {
  try {
    if (estimate.dateValue) {
      localStorage.setItem("delivery_by", estimate.dateValue);
      localStorage.setItem("delivery_by_iso", estimate.dateISO);
    } else {
      localStorage.removeItem("delivery_by");
      localStorage.removeItem("delivery_by_iso");
    }
  } catch (e) {
    /* no-op */
  }
  document.querySelectorAll("[data-delivery-arrives-by]").forEach((el) => {
    el.textContent = estimate.dateValue || "";
  });
  document.querySelectorAll("[data-delivery-pincode]").forEach((el) => {
    el.textContent = estimate.pincode || "";
  });
}

// Estimate from an element's data-* attributes — used by the cart's
// <delivery-options> (assets/custom.js), which has no badge of its own.
// Declared, not assigned as an anonymous function: this file is a classic
// script, so a top-level declaration already *is* window.<name> — overwriting
// it with a wrapper that calls the same name recurses into itself.
function computeDeliveryEstimate(dataset, overrides) {
  return estimateDelivery(deliveryConfig(dataset, overrides));
}
window.computeDeliveryEstimate = computeDeliveryEstimate;
window.publishDeliveryEstimate = publishDeliveryEstimate;

class DeliveryBadge extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector(".delivery-badge__text");

    this.cfg = deliveryConfig(this.dataset);
    this.context = this.dataset.context || "";

    this.templates = {
      no_pincode:
        this.dataset.textNoPincode || DELIVERY_BADGE_DEFAULTS.no_pincode,
      local: this.dataset.textLocal || DELIVERY_BADGE_DEFAULTS.local,
      pan: this.dataset.textPan || DELIVERY_BADGE_DEFAULTS.pan,
      sdd: this.dataset.textSdd || DELIVERY_BADGE_DEFAULTS.sdd,
      failed: this.dataset.textFailed || DELIVERY_BADGE_DEFAULTS.failed,
    };

    this.render();
    this._onUpdate = () => this.render();
    document.documentElement.addEventListener(
      "delivery:updated",
      this._onUpdate,
    );
    // Recompute periodically so the date rolls over at the cutoff / midnight
    // and the {countdown} stays fresh.
    this._timer = setInterval(() => this.render(), 60000);

    // Click / keyboard opens the pincode modal: on the pincode itself (to
    // change it) or on the "Check" button in the initial no-pincode state.
    this._onPincodeActivate = (e) => {
      const pincodeTarget = e.target.closest(".delivery-badge__pincode");
      const checkTarget = e.target.closest(".delivery-badge__check");
      const isPrompt = this.classList.contains("delivery-badge--prompt");
      const target = pincodeTarget || checkTarget || (isPrompt ? this : null);
      if (!target) return;
      if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      window.openPincodeChangeModal({
        productId: this.dataset.productId,
        productTitle: this.dataset.productTitle,
        productLocal: this.dataset.productLocal,
        pincode: pincodeTarget ? pincodeTarget.textContent.trim() : "",
        fromCart: this.context === "cart",
      });
    };
    this.addEventListener("click", this._onPincodeActivate);
    this.addEventListener("keydown", this._onPincodeActivate);
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener(
      "delivery:updated",
      this._onUpdate,
    );
    if (this._timer) clearInterval(this._timer);
  }

  render() {
    if (!this.textEl) return;

    const estimate = estimateDelivery(this.cfg);
    // Publishes the delivery-by date + pincode to the cart's delivery options
    // and the datepicker (earliest selectable date).
    publishDeliveryEstimate(estimate);

    this.classList.toggle("delivery-badge--failed", estimate.isFailed);
    // Initial state: prompt + a "Check" button that opens the pincode modal.
    const isPrompt = estimate.isPrompt;
    this.classList.toggle("delivery-badge--prompt", isPrompt);

    const displayPincode = estimate.displayPincode;
    const values = {
      date: estimate.dateValue,
      countdown: estimate.countdown,
      pincode: displayPincode,
      cutoff: estimate.cutoff,
    };

    const template = this.templates[estimate.key] || this.templates.no_pincode;
    if (!template) {
      this.setAttribute("hidden", "");
      return;
    }
    this.removeAttribute("hidden");
    // The pincode is tappable wherever it's shown (product page and cart) so
    // shoppers can open the modal to change/retry it.
    let html = fillBadgeTemplate(template, values, {
      pincodeClickable: !!displayPincode,
    });
    if (isPrompt) {
      const label = this.dataset.checkLabel || "Check";
      html += `<button type="button" class="delivery-badge__check">${escapeHtml(
        label,
      )}</button>`;
    }
    this.textEl.innerHTML = html;
  }
}

window.customElements.define("delivery-badge", DeliveryBadge);
